import { Table, Switch, Tooltip, Modal, Popover } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import FallbackImage from "../../../components/FallbackImage";
import { selectUser } from "../../../redux/slices/user";
import { getColumnSearchProps } from "../../../utils/tables";
import Header from "../../../components/HeaderList";
import styles from "../styles/ProductsUI.module.css";


import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PriceEditor from "../../products/components/PriceEditor";
import { selectSuggestedSections } from "../../../redux/slices/products";

const FALLBACK_PHOTO = <PictureOutlined style={{ fontSize: '18px', color: '#ccc' }} />;

const SuggestsUI = (props) => {
  const {
    loading,
    products,
    handleProductSection,
    categories,
    visibleEditor,
    closeEditor,
    // effectiveBranch,
  } = props;

  const user = useSelector(selectUser);
  const suggestedSections = useSelector(selectSuggestedSections);
  const { pathname } = useLocation();

  const hasAnyChannelActive = (record) => {
    return Array.isArray(record.channels) && record.channels.some(c => c.active === 1 || c.active === true);
  };

  const getCategoryName = (role) => {
    const index = categories.findIndex((el) => el.value === role);
    if (index > -1) {
      return categories[index].text;
    }
    return "-";
  };

  const columns = [
    {
      title: "Foto",
      dataIndex: "photo",
      align: "center",
      render: (photo) => {
        if (!photo) {
          return <PictureOutlined style={{ fontSize: '18px', color: '#ccc' }} />;
        }
        const content = (
          <div style={{ padding: '4px' }}>
            <FallbackImage src={photo} alt="Producto" style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'cover', borderRadius: '4px' }} fallback={FALLBACK_PHOTO} />
          </div>
        );
        return (
          <Popover content={content} trigger="hover" placement="right">
            <PictureOutlined style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }} />
          </Popover>
        );
      }
    },
    ...(user.admin === 1 && !pathname.includes("productos-por-sucursal") ? [{
      title: "SKU",
      dataIndex: "sku",
      ...getColumnSearchProps("sku"),
    }] : []),
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Descripción",
      dataIndex: "description",
      width: 200,
      render: (val) => (
        <Tooltip placement="bottom" title={val}>
          <span className={styles.description}>{val}</span>
        </Tooltip>
      ),
    },
    {
      title: "Categoría",
      dataIndex: "id_category",
      align: "center",
      filters: categories,
      onFilter: (val, record) => record.id_category === val,
      render: (val) => getCategoryName(val),
    },
    {
      title: "Precio",
      dataIndex: "price",
      align: "center",
      render: (val) => `$${Number(val || 0).toFixed(2)}`,
    },
    ...suggestedSections.map((sec) => ({
      title: `Sugerido (${sec.name})`,
      align: "center",
      sorter: (a, b) => {
        const aActive = hasAnyChannelActive(a);
        const bActive = hasAnyChannelActive(b);
        const aVal = (aActive && a.suggested_sections && a.suggested_sections[sec.id]) ? 1 : 0;
        const bVal = (bActive && b.suggested_sections && b.suggested_sections[sec.id]) ? 1 : 0;
        return aVal - bVal;
      },
      filters: [
        { text: "Activo", value: 1 },
        { text: "Inactivo", value: 0 },
      ],
      filterMultiple: false,
      onFilter: (value, record) => {
        const isActive = hasAnyChannelActive(record);
        const val = (isActive && record.suggested_sections && record.suggested_sections[sec.id] === 1) ? 1 : 0;
        return val === value;
      },
      render: (_, record) => {
        const isActive = hasAnyChannelActive(record);
        const isSuggested = record.suggested_sections && record.suggested_sections[sec.id] === 1;
        const switchElement = (
          <Switch
            checked={isActive ? isSuggested : false}
            disabled={!isActive}
            onChange={() => handleProductSection(record.id, isSuggested ? 1 : 0, sec.id, user.id)}
            checkedChildren="Si"
            unCheckedChildren="No"
          />
        );
        if (!isActive) {
          return (
            <Tooltip title="El producto debe tener al menos un canal activo para poder ser sugerido.">
              <span>{switchElement}</span>
            </Tooltip>
          );
        }
        return switchElement;
      }
    })),

  ];

  return (
    <div className={styles.view}>
      <Header back={pathname.includes("productos-por-sucursal") ? "/productos-por-sucursal" : "/productos"} title="Productos Sugeridos" />
      <Modal
        destroyOnClose
        wrapClassName={styles.modal}
        footer={false}
        visible={visibleEditor}
        width={300}
        closable={false}
        onCancel={closeEditor}
      >
        <PriceEditor closeEditor={closeEditor} />
      </Modal>

      <Table columns={columns} dataSource={products} rowKey="id" loading={loading} size="small" />
    </div>
  );
};

export default SuggestsUI;
